export default __webpack_public_path__ + "static/premioParticipa-7f32b9bda17e5db381f9da91b8a2b07a.png";